const toCamel = (s) =>
  s.replace(/([-_][a-z])/ig, ($1) =>
    $1.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  )

const isObject = (o) => o === Object(o) && !isArray(o) && typeof o !== 'function'

const isArray = (a) => Array.isArray(a)

export const keysToCamel = (o) => {
  if (isObject(o)) {
    const n = {}

    Object.keys(o)
      .forEach((k) => {
        n[toCamel(k)] = o[k]
      })

    return n
  } else if (isArray(o)) {
    return o.map((i) => {
      return keysToCamel(i)
    })
  }

  return o
}

export const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export const removeHTMLTags = (htmlString) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  const textContent = doc.body.textContent || ''
  return textContent.trim()
}

export const getFileName = (url, includeExtension) => {
  const matches = url && typeof url.match === 'function' && url.match(/\/?([^/.]*)\.?([^/]*)$/)
  if (!matches) return null
  if (includeExtension && matches.length > 2 && matches[2]) {
    return matches?.slice(1)?.join('.')
  }
  return matches[1]
}
